import React from 'react';
import { ModalBody } from 'reactstrap';
import UrlForm from './url_form';
import Preview from './preview';
import { TImportBody } from './types';
import { TVideoPreview } from './preview/types';
import './ImportBody.scss';

const ImportBody: React.FC<TImportBody> = ({
  isUrlForm,
  urls,
  previews,
  onChangeUrl,
  onChangePreview
}) => {
  return (
    <ModalBody className="import-video-body">
      {isUrlForm ? (
        <UrlForm urls={urls} onChangeAction={onChangeUrl} />
      ) : (
        <Preview
          previews={previews as TVideoPreview['previews']}
          onChangePreview={onChangePreview}
        />
      )}
    </ModalBody>
  );
};

export default ImportBody;
